import { Coordinate } from 'ol/coordinate';
import { CalculationSettingsModel } from './configuration';

export class CrossSectionResultModel{
 interpolationStep: number;
 firstPointHeightToSeeLast: number;
 lastPointHeightToSeeFirst: number;
 terrainHeightsArray: number[];
}

export class CrossSectionData{
  initLat: number;
  initLong: number;

}

export class CrossSectionDTO{
  coordinates: Coordinate[];
  calculationSettings: CalculationSettingsModel;
  projectId: number;
}


